import { useMemo } from "react"
import { SHARD_ELEMENT_ICONS } from "@/constants/shards"
import { BattleCardView, GameCard } from "@/types/battle"
import { CardShapeLayout } from "./cardShapeLayout"
import { getInstalledShardSlots } from "./cardShardLayout"

interface CardShardBadgesProps {
  card: BattleCardView | GameCard
  layout: CardShapeLayout
  sizeScale?: number
}

export default function CardShardBadges({
  card,
  layout,
  sizeScale = 1,
}: CardShardBadgesProps) {
  const { scale } = layout
  const installed = useMemo(
    () => getInstalledShardSlots("shardSlots" in card ? card.shardSlots : null),
    [card]
  )

  if (installed.length === 0) return null

  const iconSize = Math.max(22, 28 * scale) * sizeScale
  const gap = Math.max(4, 5 * scale) * sizeScale
  const edge = Math.max(6, 8 * scale) * sizeScale
  const padH = Math.max(6, 7 * scale) * sizeScale
  const padV = Math.max(5, 6 * scale) * sizeScale

  return (
    <div
      className="pointer-events-none absolute z-[6] flex flex-row flex-wrap items-center justify-end overflow-visible"
      style={{
        right: edge,
        bottom: edge,
        gap,
        paddingLeft: padH,
        paddingRight: padH,
        paddingTop: padV,
        paddingBottom: padV,
        borderRadius: Math.max(8, 10 * scale) * sizeScale,
        maxWidth: layout.innerW * 0.55,
        backgroundColor: "rgba(0,0,0,0.45)",
      }}
    >
      {installed.map(({ slotIndex, shard }) => (
        <img
          key={`shard-${slotIndex}`}
          src={SHARD_ELEMENT_ICONS[shard.element]}
          alt=""
          width={iconSize}
          height={iconSize}
          className="object-contain"
        />
      ))}
    </div>
  )
}
